<template>
  <div class="shenyunjie-chart-atmos" :id="id"></div>
</template>

<script>
import * as echarts from "echarts";
import merge from "deepmerge";

export default {
  name: "YunJieChartAtmos",
  props: {
    id: {
      type: String,
      default: function () {
        return new Date().getTime() + "-" + Math.ceil(Math.random() * 1000);
      }
    },
    loadChart: {
      type: Boolean,
      default: true
    },
    theme: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    atmos: {
      type: Number,
      default: null
    },
    value: {
      type: Number,
      default: null
    },
    option: {
      type: Object,
      default: function () {
        return {}
      }
    },
    updateOption: {
      type: Function,
      default: null
    }
  },
  components: {},
  data() {
    return {
      chart: null,
      defaultOption: {
        grid: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        }
      },
      resizeObserver: null
    };
  },
  mounted() {
    let self = this;
    // 窗口大小变化监听
    window.addEventListener("resize", self.resizeAtmos);
    // 元素大小变化监听
    self.resizeObserver = new ResizeObserver((entries) => {
      if (self.chart) {
        self.chart.dispose();
        this.chart = null;
      }
      self.init();
    });
    self.resizeObserver.observe(document.getElementById(self.id));
    if (self.loadChart) {
      self.init();
    }
  },
  methods: {
    resizeAtmos() {
      let self = this;
      if (self.chart) {
        self.chart.resize();
      }
    },
    init() {
      let self = this;
      // 页面已存在
      if (document.getElementById(self.id) && document.getElementById(self.id).offsetHeight > 0) {
        // 初始化
        if (!self.chart) {
          let theme = self.theme || (this.$YunJie || {}).theme || "standard";
          if (theme == "darkness") {
            self.chart = echarts.init(document.getElementById(self.id), "dark");
          } else {
            self.chart = echarts.init(document.getElementById(self.id));
          }
        }
        let value = 0;
        if (self.atmos != null) {
          value = self.atmos * 101.325;
        } else if (self.value) {
          value = self.value / 1000;
        }
        // 配置汇总
        let parameter = {
          title: {
            text: self.title,
            left: "center",
            top: "middle"
          },
          series: [{
            type: "gauge",
            min: 50662.5 / 1000,
            max: 253312.5 / 1000,
            data: [{
              value: value,
              name: "kPa\natm"
            }],
            splitNumber: 10,
            radius: "80%",
            center: ["50%", "57%"],
            axisLine: {
              lineStyle: {
                color: [[1, "#ff0000"]],
                width: 3
              }
            },
            splitLine: {
              distance: -18,
              length: 18,
              lineStyle: {
                color: "#ff0000"
              }
            },
            axisTick: {
              distance: -12,
              length: 10,
              lineStyle: {
                color: "#ff0000"
              }
            },
            axisLabel: {
              distance: -40,
              color: "#ff0000",
              fontSize: 14,
              formatter: function (value) {
                return Math.round(value);
              }
            },
            anchor: {
              show: true,
              size: 20,
              itemStyle: {
                borderColor: self.theme == "darkness" ? "#ffffff" : "#000000",
                borderWidth: 2
              }
            },
            pointer: {
              offsetCenter: [0, "10%"],
              icon: "path://M2090.36389,615.30999 L2090.36389,615.30999 C2091.48372,615.30999 2092.40383,616.194028 2092.44859,617.312956 L2096.90698,728.755929 C2097.05155,732.369577 2094.2393,735.416212 2090.62566,735.56078 C2090.53845,735.564269 2090.45117,735.566014 2090.36389,735.566014 L2090.36389,735.566014 C2086.74736,735.566014 2083.81557,732.63423 2083.81557,729.017692 C2083.81557,728.930412 2083.81732,728.84314 2083.82081,728.755929 L2088.2792,617.312956 C2088.32396,616.194028 2089.24407,615.30999 2090.36389,615.30999 Z",
              length: "115%",
              itemStyle: {
                color: self.theme == "darkness" ? "#ffffff" : "#000000"
              }
            },
            detail: {
              valueAnimation: true,
              fontSize: 24,
              formatter: function (value) {
                return Math.round(value * 1000) / 1000;
              }
            },
            title: {
              offsetCenter: [0, "-50%"]
            }
          }, {
            type: "gauge",
            min: 0.5,
            max: 2.5,
            splitNumber: 5,
            center: ["50%", "57%"],
            axisLine: {
              lineStyle: {
                color: [[1, self.theme == "darkness" ? "#ffffff" : "#000000"]],
                width: 3
              }
            },
            splitLine: {
              distance: -3,
              length: 18,
              lineStyle: {
                color: self.theme == "darkness" ? "#ffffff" : "#000000"
              }
            },
            axisTick: {
              distance: 0,
              length: 10,
              lineStyle: {
                color: self.theme == "darkness" ? "#ffffff" : "#000000"
              }
            },
            axisLabel: {
              distance: 10,
              fontSize: 14,
              color: self.theme == "darkness" ? "#ffffff" : "#000000"
            },
            pointer: {
              show: false
            },
            title: {
              show: false
            },
            anchor: {
              show: true,
              size: 14,
              itemStyle: {
                color: self.theme == "darkness" ? "#ffffff" : "#000000"
              }
            }
          }]
        };
        let opt = merge(self.defaultOption, parameter);
        // 合并自定义配置
        opt = merge(opt, self.option);
        // 用户自定义属性
        if (self.updateOption) {
          opt = self.updateOption(opt);
        }
        self.chart.setOption(opt, true);
        self.chart.resize();
      }
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeAtmos);
    this.resizeObserver.disconnect();
  },
  watch: {
    theme() {
      // 销毁已有曲线
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
      this.init();
    },
    title() {
      this.init();
    },
    atmos() {
      this.init();
    },
    value() {
      this.init();
    },
    option: {
      deep: true,
      handler(option) {
        this.init();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.shenyunjie-chart-atmos {
  height: 100%;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/charts/atmos.vue